import styled from "styled-components";

import { useContext } from "react";
import { Divider } from "../../../../../../commonStyles";
import { ModalContext } from "../../../../../Common/Modal";
import PostAs from "./PostAs";
import PostTo from "./PostTo";

export const CreateRepostHeader = () => {
  const { headerRef } = useContext(ModalContext);

  return (
    <HeaderContainer ref={headerRef}>
      <PostAsAndToContainer>
        <PostAs />
        <Divider />
        <PostTo />
      </PostAsAndToContainer>
    </HeaderContainer>
  );
};

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
`;

const PostAsAndToContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 306px;
  width: 100%;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
`;
